function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M480-483l-68 52q-6 5-12 .5t-4-11.5l26-84-70-56q-5-5-3-11.5t9-6.5h86l26-82q2-7 10-7t10 7l26 82h85q7 0 9.5 6.5T608-582l-71 56 26 84q2 7-4 11.5t-12-.5l-67-52zm0 363L293-58q-20 7-36.5-5T240-95v-254q-38-42-59-96t-21-115q0-134 93-227t227-93q134 0 227 93t93 227q0 61-21 115t-59 96v254q0 20-16.5 32T667-58l-187-62zm0-200q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70zM320-159l160-41 160 41v-124q-35 20-75.5 31.5T480-240q-44 0-84.5-11.5T320-283v124zm160-62z"
  }));
};
const SvgRibbonAlt = styled(BaseComponent).withConfig({
  displayName: "RibbonAlt__SvgRibbonAlt",
  componentId: "sc-1mn1rls-0"
})(["outline:none;"]);
SvgRibbonAlt.isIcon = true;
export default SvgRibbonAlt;